import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deletePhonecentersMaintenance = ({ phonecentersMaintenanceId }: { phonecentersMaintenanceId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/PhonecentersMaintenance/DeletePhonecentersMaintenance/${phonecentersMaintenanceId}`);
};

type QueryFnType = typeof deletePhonecentersMaintenance;

type UseDeletePhonecentersMaintenanceOptions = {
  phonecentersMaintenanceId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeletePhonecentersMaintenance = ({ config }: UseDeletePhonecentersMaintenanceOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllPhonecentersMaintenances"]);
      addNotification(`Ο Συντηρητής Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deletePhonecentersMaintenance,
  });
};
